import useHasPermission from 'app/hooks/useHasPermission'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useContactManagementRoutes from 'app/SkyNetRoutes/hooks/useContactManagementRoutes'

import {
    CommonRoutes,
} from 'app/enums/common.enums'
import requests from 'app/requests/BillingCompany.requests'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import BillingCompanyOverview from './BillingCompanyOverview'
import BillingCompanyChangeSummary from './BillingCompanyChangeSummary'
import BillingCompanyDataUpdate from './BillingCompanyDataUpdate'
import BillingCompanyCreate from './BillingCompanyCreate'
import tableConfig from './BillingCompanies.config'
import CustomerSalesArea from './CustomerSalesArea'
import Communication from './Communication'
import SalesAreaTax from './SalesAreaTax'
import Abacus from './Abacus'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ShowArhived,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const BillingCompanies = () => {
    const hasCreatePermission = useHasPermission(['billing_company_create'])
    const hasUpdatePermission = useHasPermission(['billing_company_update'])
    const {
        BillingCompanies: BillingCompaniesRoutes,
    } = useContactManagementRoutes()

    const tabs = useTabsByPermission([
        {
            tab: {
                url: CommonRoutes.Overview,
                label: 'Overview',
                Component: BillingCompanyOverview,
            },
            permission: true,
        },
        {
            tab: {
                url: CommonRoutes.DataUpdate,
                label: 'Data Update',
                Component: BillingCompanyDataUpdate,
            },
            permission: hasUpdatePermission,
        },
        {
            tab: {
                url: BillingCompaniesRoutes.Communication.route,
                label: 'Communication',
                Component: Communication,
            },
            permission: hasUpdatePermission,
        },
        {
            tab: {
                url: BillingCompaniesRoutes.CustomerSalesArea.route,
                label: 'Customer Sales Area',
                Component: CustomerSalesArea,
            },
            permission: hasUpdatePermission,
        },
        {
            tab: {
                url: BillingCompaniesRoutes.SalesAreaTax.route,
                label: 'Sales Area Tax',
                Component: SalesAreaTax,
            },
            permission: hasUpdatePermission,
        },
        {
            tab: {
                url: BillingCompaniesRoutes.Abacus.route,
                label: 'Abacus',
                Component: Abacus,
            },
            permission: hasUpdatePermission,
        },
        {
            tab: {
                url: CommonRoutes.ChangeHistory,
                label: 'Change History',
                Component: BillingCompanyChangeSummary,
            },
            permission: true,
        },
    ])

    return (
        <SkyNetDomain
            actionComponents={{
                Create: hasCreatePermission
                    ? BillingCompanyCreate
                    : undefined,
            }}
            name={requests.domainName}
            sidebarTabs={tabs}
        >
            <SkyNetTable
                tableControls={tableControls}
                tableConfig={tableConfig}
                customUrl={requests.filterRequest().url}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default BillingCompanies
